import React, { useState } from "react"
import { Dialog } from 'primereact/dialog'

import LogoImg from '../images/pm_logo.png'

import "./index.css"
import { Oval } from "react-loader-spinner"

const InitLoading = (props) => {
    const { visible } = props

    return (
        <div className="">
            <Dialog visible={visible} headerStyle={{display: 'none'}} contentStyle={{background: 'none', height: '100vh', boxShadow: 0, display: 'flex', justifyContent: 'center'}} maskClassName="loading-mask" maskStyle={{backgroundColor: '#eff3f8', animation: 'none'}} className="loading-modal" style={{ width: '50vw' }} >
                <div className="flex flex-column justify-content-between align-items-center">
                    <div className=""></div>
                    <Oval
                        height={45}
                        width={45}
                        color="#00baac"
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#a4a7a6"
                    />
                    <img src={LogoImg} style={{width: "170px"}} alt="" />
                </div>
            </Dialog>
        </div>
    )
}

export default InitLoading